import { createApp, ref } from "vue";
import tpl from "./confirm.vue";
import { setupRouter } from "@/core/router";
import { setupAntDesign } from "@/core/setup/setupAntDesign";
import { setupGlobalComponents } from "@/core/setup/setupGlobalComponents";
import { setupGlobalFilters } from "@/core/setup/setupGlobalFilters";
import store,{setupStore} from "@/store";
import VxeUI from 'vxe-pc-ui'
import "xe-utils";
import VXETable from "vxe-table";
import "@/components/table-wrapper/index.scss";
const isShowing = false;
/**
 * 使用方式
 * import {} from ''
 * hmdConfirm({
     com:import('@/dialog/tpl/commercialInformationQuery.vue'),
     style: {},//模板容器设置css
     params :{},//传给模板组件的参数
     paddingTop:20,//弹框距离顶部的距离这里是百分比，默认是上下居中
     lazy:false,//延时关闭，默认false
     duration:2,//默认2秒
     hideMask:false,//是否关闭遮罩层的背景色，默认false
     close:()=>{},//close回调
     cancel:()=>{},//取消回调
     confirm:({params,res})=>{}//确认回调
  });
 * @param options
 */
export const hmdConfirm = (options) => {
  /* fix 弹窗出来之后依旧键盘没有回收*/
  const inputs = Array.prototype.slice.call(document.querySelectorAll("input"));
  inputs.forEach((input) => input.blur());
  const instance = createApp(tpl);
  setupAntDesign(instance);
  setupGlobalComponents(instance);
  setupGlobalFilters(instance);
  // instance.use(VXETable);
  instance.use(VxeUI).use(VXETable);
  instance.use(store);
  instance.use(VXETable);
  setupRouter(instance);
  setupStore(instance);
  options.zIndex = options.zIndex ? options.zIndex : store.state.user.zIndex + 1;
  store.commit("user/SET_zIndex", options.zIndex);
  instance.provide("config", options);
  const root = document.createElement("div");
  document.body.appendChild(root);
  instance.mount(root);
};
export default {
  install: (app) => {
    app.config.globalProperties.$hmdConfirm = hmdConfirm;
  },
};
